import React, { PropTypes } from "react";
import Component from "react-pure-render/component";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import DragLayer from "../components/dragLayer.react";
import InputCustom from "../components/inputCustom.react";
import Modal from "../components/modal.react";
import FieldDragAndDrop from "./fieldDragAndDrop.react";
import Gallery from "../galleries/galleryTemplateField.react";
import EditSection from "./editSection.react";
import RemoveSection from "./removeSection.react";
import AddGallery from "./addGallery.react";
import AddField from "../field/addField.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

const itemSource = {
  beginDrag(props) {
    const { setDraggingItemUID } = props;
    setDraggingItemUID(props.itemUID);
    return {
      itemUID: props.itemUID
    };
  },
  endDrag(props, monitor, component) {
    const { setDraggingItemUID, setHoveringItemUID, dropAction } = props;
    if (dropAction) {
      dropAction();
    }
    setDraggingItemUID("");
    setHoveringItemUID("");
  }
};

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().itemUID;
    const hoverIndex = props.itemUID;

    if (dragIndex === hoverIndex) {
      return;
    }

    const { setHoveringItemUID, hoveringItemUID } = props;
    setHoveringItemUID(hoverIndex);

    if (hoverIndex === hoveringItemUID) {
      return;
    }

    const { moveAction, moveActionProps } = props;
    if (moveAction) {
      moveAction(dragIndex, hoverIndex, moveActionProps);
    }
  }
};

function getTypes(props) {
  return props.types;
}

class SectionDragAndDrop extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    itemUID: PropTypes.string.isRequired,
    types: PropTypes.string.isRequired,
    setDraggingItemUID: PropTypes.func.isRequired,
    draggingItemUID: PropTypes.string.isRequired,
    setHoveringItemUID: PropTypes.func.isRequired,
    hoveringItemUID: PropTypes.string.isRequired,
    moveAction: PropTypes.func,
    moveActionProps: PropTypes.object,
    dropAction: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      wrapperWidth: 0
    };
    this.getElementWrapperWidth = this.getElementWrapperWidth.bind(this);
  }

  componentDidMount() {
    this.getElementWrapperWidth();
    window.addEventListener("resize", this.getElementWrapperWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getElementWrapperWidth);
  }

  getElementWrapperWidth = () => {
    const { elementWrapper } = this.refs;
    this.setState({
      wrapperWidth: findDOMNode(elementWrapper).getBoundingClientRect().width
    });
  };

  renderLayer = () => {
    const {
      itemUID,
      draggingItemUID,
      section,
      actions,
      uid,
      afterServerActionSuccess,
      notificationSystem,
      fields,
      hoveringItemUID,
      galleries
    } = this.props;
    const self = this;
    const fieldsHTML =
      section && section.get("fields")
        ? section
            .get("fields")
            .sort(
              (a, b) => fields.getIn([a, "sort"]) - fields.getIn([b, "sort"])
            )
            .map(function(fieldUID, fieldIndex) {
              const field = fields.getIn([fieldUID]);
              if (field) {
                return (
                  <FieldDragAndDrop
                    dropAction={self.dropAction}
                    hoveringItemUID={hoveringItemUID}
                    setHoveringItemUID={actions.setHoveringItemUID}
                    moveAction={actions.moveField}
                    key={fieldIndex}
                    itemUID={field.get("uid")}
                    types="field"
                    setDraggingItemUID={actions.setDraggingItemUID}
                    draggingItemUID={draggingItemUID}
                    uid={uid}
                    afterServerActionSuccess={afterServerActionSuccess}
                    actions={actions}
                    field={field}
                    notificationSystem={notificationSystem}
                    isRemoveModalVisible={false}
                  />
                );
              }
            })
        : "";

    const galleriesHTML =
      section && section.get("galleries")
        ? section.get("galleries").map(function(gallery, index) {
            gallery = galleries.get(gallery);
            if (gallery) {
              return (
                <Gallery
                  key={index}
                  uid={uid}
                  afterServerActionSuccess={afterServerActionSuccess}
                  actions={actions}
                  gallery={gallery}
                  notificationSystem={notificationSystem}
                  isRemoveModalVisible={false}
                />
              );
            }
          })
        : "";

    const editSectionProps = {
      actions: actions,
      feature: "sections",
      entity: section,
      uid: section
    };
    if (itemUID === draggingItemUID) {
      return (
        <DragLayer wrapperWidth={this.state.wrapperWidth}>
          <section className="row middle-xs">
            <h3 className="col-xs-12">
              {section.get("name")} {section.get("sort")}
            </h3>
            <div className="col-xs-3">
              <div className="row">
                <RemoveSection
                  sectionUID={section}
                  objectUID={uid}
                  isRemoveModalVisible={false}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <EditSection
                  sectionUID={section}
                  objectUID={uid}
                  isEditModalVisible={false}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <AddField
                  objectUID={uid}
                  sectionUID={section}
                  isAddModalVisible={false}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <AddGallery
                  objectUID={uid}
                  sectionUID={section}
                  isAddModalVisible={false}
                />
              </div>
            </div>
            <hr />
            {fieldsHTML}
            {galleriesHTML}
            <div className="col-xs-12" />
          </section>
        </DragLayer>
      );
    }
  };

  dropAction = () => {
    const {
      draggingItemUID,
      hoveringItemUID,
      fields,
      actions,
      uid,
      afterServerActionSuccess,
      notificationSystem
    } = this.props;
    const dragField = fields.get(draggingItemUID);
    const dropField = fields.get(hoveringItemUID);
    actions
      .updateField(fields.get(draggingItemUID), draggingItemUID)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
        afterServerActionSuccess(uid);
      });
  };

  render() {
    const {
      draggingItemUID,
      itemUID,
      connectDragSource,
      connectDropTarget,
      fields,
      actions,
      isRemoveModalVisible,
      section,
      uid,
      afterServerActionSuccess,
      notificationSystem,
      isRemoveSectionModalVisible,
      isEditSectionModalVisible,
      isAddFieldModalVisible,
      addFieldFormProps,
      isAddGalleryModalVisible,
      addGalleryFormProps,
      hoveringItemUID,
      isRemoveFieldModalVisible,
      galleries,
      isRemoveGalleryModalVisible
    } = this.props;
    const opacity = itemUID === draggingItemUID ? 0 : 1;
    const width = "100%";
    const self = this;
    const fieldsHTML =
      section && section.get("fields")
        ? section
            .get("fields")
            .sort(
              (a, b) => fields.getIn([a, "sort"]) - fields.getIn([b, "sort"])
            )
            .map(function(fieldUID, fieldIndex) {
              const field = fields.getIn([fieldUID]);
              if (field) {
                return (
                  <FieldDragAndDrop
                    dropAction={self.dropAction}
                    hoveringItemUID={hoveringItemUID}
                    setHoveringItemUID={actions.setHoveringItemUID}
                    moveAction={actions.moveField}
                    key={fieldIndex}
                    itemUID={field.get("uid")}
                    types="field"
                    setDraggingItemUID={actions.setDraggingItemUID}
                    draggingItemUID={draggingItemUID}
                    uid={uid}
                    afterServerActionSuccess={afterServerActionSuccess}
                    actions={actions}
                    field={field}
                    notificationSystem={notificationSystem}
                    isRemoveModalVisible={isRemoveFieldModalVisible}
                  />
                );
              }
            })
        : "";

    const galleriesHTML =
      section && section.get("galleries")
        ? section.get("galleries").map(function(gallery, index) {
            gallery = galleries.get(gallery);
            if (gallery) {
              return (
                <Gallery
                  key={index}
                  uid={uid}
                  afterServerActionSuccess={afterServerActionSuccess}
                  actions={actions}
                  gallery={gallery}
                  notificationSystem={notificationSystem}
                  isRemoveModalVisible={isRemoveGalleryModalVisible}
                />
              );
            }
          })
        : "";

    const editSectionProps = {
      actions: actions,
      feature: "sections",
      entity: section,
      uid: section
    };

    return connectDropTarget(
      <div style={{ width }}>
        <div style={{ opacity, width }} ref="elementWrapper">
          <section className="row middle-xs">
            {connectDragSource(
              <h3 className="col-xs-12">
                {section.get("name")} {section.get("sort")}
              </h3>
            )}
            <div className="col-xs-3">
              <div className="row">
                <RemoveSection
                  sectionUID={section.get("uid")}
                  objectUID={uid}
                  afterEditSuccessAction={afterServerActionSuccess}
                  actions={actions}
                  notificationSystem={notificationSystem}
                  isRemoveModalVisible={isRemoveSectionModalVisible}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <EditSection
                  sectionUID={section}
                  afterEditSuccessAction={afterServerActionSuccess}
                  objectUID={uid}
                  actions={actions}
                  notificationSystem={notificationSystem}
                  isEditModalVisible={isEditSectionModalVisible}
                  editSectionProps={editSectionProps}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <AddField
                  afterAddSuccessAction={afterServerActionSuccess}
                  objectUID={uid}
                  actions={actions}
                  sectionUID={section.get("uid")}
                  notificationSystem={notificationSystem}
                  isAddModalVisible={isAddFieldModalVisible}
                  addFieldFormProps={addFieldFormProps}
                />
              </div>
            </div>
            <div className="col-xs-3">
              <div className="row">
                <AddGallery
                  afterAddSuccessAction={afterServerActionSuccess}
                  objectUID={uid}
                  actions={actions}
                  sectionUID={section.get("uid")}
                  notificationSystem={notificationSystem}
                  isAddModalVisible={isAddGalleryModalVisible}
                  addGalleryFormProps={addGalleryFormProps}
                />
              </div>
            </div>
            <hr />
            {fieldsHTML}
            {galleriesHTML}
            <div className="col-xs-12" />
          </section>
        </div>
        {this.renderLayer()}
      </div>
    );
  }
}
export default DropTarget(getTypes, itemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(
  DragSource(getTypes, itemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))(SectionDragAndDrop)
);



// WEBPACK FOOTER //
// ./src/browser/template/sectionDragAndDrop.react.js